// instrument.js — v5.16
//
// One place to answer "how do I display this instrument?", so components stop
// carrying their own copies of the asset roster.
//
// ⚠ WHY THIS EXISTS. Seven dashboard components hardcoded either the asset list
// or a `symbol === "USDJPY" ? 3 : 5` decimals rule. After the v5.14 swap that was
// wrong twice over: it still listed USDJPY/USDCHF/USDCAD, which the engine no
// longer trades, and it rendered US500 at FIVE decimals — 7698.30000 for an index
// that quotes to 7698.30. The backend now serves `asset_meta` (derived from
// config) on /intelligence and /brain/calibration_status; prefer that everywhere.

// Decimals for a symbol.
//
// `meta` is the backend's asset_meta map when the component has it. The fallback
// is deliberately NOT a symbol list — a list is exactly what went stale. It infers
// from the quote instead: FX majors trade near 1, JPY crosses near 100, and
// indices/metals in the thousands, so magnitude separates them without anyone
// having to maintain a roster.
export function decimalsFor(symbol, price, meta) {
  const d = meta?.[symbol]?.decimals;
  if (typeof d === "number") return d;

  const p = Math.abs(Number(price) || 0);
  if (p >= 100) return 2;   // indices, gold, JPY crosses quote coarsely
  if (p >= 10) return 3;    // JPY-style crosses
  return 5;                 // FX majors
}

// Format a price at its own precision.
export function fmtPrice(symbol, price, meta) {
  const v = Number(price);
  if (!isFinite(v) || v === 0) return "—";
  return v.toFixed(decimalsFor(symbol, v, meta));
}
